import React from "react";
import Button from "@/ui/Button/Button";
import { useAdminPriceEdaContext } from "./context";
import cls from "./styles.module.scss";

export const EditorConfirmBar = () => {
  const {
    editor: { pendingCount, confirmPending, saving },
  } = useAdminPriceEdaContext();

  if (!pendingCount) return null;

  return (
    <div className={cls.confirmBar}>
      <Button
        type="button"
        label={`Подтвердить ${pendingCount}`}
        onClick={confirmPending}
        loading={saving}
      />
    </div>
  );
};
